import styled from 'styled-components'
import {ButtonStyleType} from 'src/types/type'

type BtnStyleProps = Partial<ButtonStyleType> & {
    isLoading?: boolean;
}

type IconStyleProps = {
    $iconPosition?: 'left' | 'right'
    $iconSize?: number
    $iconGap?: number
     $iconInline?: boolean  
}
export const DefaultButton = styled.button.attrs({type: 'button'})<BtnStyleProps>`
    width: 100%;
    height: ${({height = '50px'}) => height};
    line-height: ${({height = '50px'}) => height};
    border-radius: ${({borderRadius = '12px'}) => borderRadius};
    border: 1px solid #eee;
    background-color: ${({backgroundColor = '#fff'}) => backgroundColor};
    color: ${({fontColor = '#666'}) => fontColor};
    font-size: ${({fontSize = '14px'}) => fontSize};
    font-family: ${({fontFamily = 'inherit'}) => fontFamily};
    font-weight: ${({fontWeight = 400}) => fontWeight};
    letter-spacing: ${({letterSpacing = 'normal'}) => letterSpacing};

    &:not(:disabled):active {
        background-color: #f1f1f1;
    }

    &:not([disabled]) {
        cursor: pointer;
    }

    &:disabled {
        color: #fff;
        background-color: #CCD0D8;
        border: 1px solid #CCD0D8;
        cursor: not-allowed;
        pointer-events: none;
    }

    -webkit-tap-highlight-color: transparent;
    touch-action: manipulation;
`

export const PrimaryButton = styled(DefaultButton)`
    background-color: ${({backgroundColor}) => backgroundColor ?? '#1A6EFF'};
    color: ${({fontColor}) => fontColor ?? '#fff'};
    border: 1px solid #1A6EFF;
    font-weight: ${({fontWeight = 700}) => fontWeight};
    &.btn_send_sms {
        margin-top: 10px;
    }
    &.btn_resend_sms {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: center;
        width: 57px;
        height: 38px;
        padding: 5px 8px;
        font-size: 14px;
        font-weight: 400;
        border-radius: 8px;
    }
    &.btn_signup {
        height:58px;
        line-height: 58px;
    }
    
    &:not(:disabled):active {
        background-color: ${({backgroundColor}) => backgroundColor ?? '#1A6EFF'};
    }

    &:disabled {
        ${({isLoading, backgroundColor}) => isLoading && `
         background-color: ${backgroundColor ?? '#CCD0D8'} !important;
            color: #fff !important;
             border: 1px solid ${backgroundColor ?? '#CCD0D8'} !important;
            cursor: not-allowed;
            pointer-events: none;
        `}
    } 
`

export const SecondaryButton = styled(DefaultButton)`
    background-color: ${({backgroundColor}) => backgroundColor ?? '#F0F6FF'};
    color: ${({fontColor}) => fontColor ?? '#1A6EFF'};
    border: 1px solid ${({backgroundColor}) => backgroundColor ?? '#F0F6FF'};

    &:not(:disabled):active {
        background-color: #F0F6FF;
        border-color: #F0F6FF;
        color: #1A6EFF;
    }

   

    &:disabled {
        ${({isLoading, backgroundColor}) => isLoading && `
        background-color: ${backgroundColor ?? '#F0F6FF'} !important;
        color: #1A6EFF !important;
        border: 1px solid ${backgroundColor ?? '#F0F6FF'} !important;
        cursor: not-allowed;
        pointer-events: none;
    `}
    }
`

export const IconSlot = styled.span<IconStyleProps>`
  ${({ $iconInline }) =>
    $iconInline
      ? `
        position: static;
        top: auto;
        transform: none;
        display: inline-flex;
        align-items: center;
        justify-content: center;
      `
      : `
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
      `}

  ${({ $iconInline, $iconPosition = 'right', $iconSize = 24, $iconGap = 8 }) =>
    $iconInline
      ? `
        width: ${$iconSize}px;
        height: ${$iconSize}px;
        flex: 0 0 ${$iconSize}px;
      `
      : `
        ${$iconPosition === 'left' ? 'left: 16px;' : 'right: 16px;'}
        width: ${$iconSize}px;
        height: ${$iconSize}px;
      `}

  pointer-events: none;

  & > div {
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
  }
  & > img, & > svg {
    display: block;
  }
`

export const StyledIconButton = styled(PrimaryButton)<IconStyleProps>`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  ${({ $iconInline, $iconGap = 8 }) =>
    $iconInline &&
    `
      gap: ${$iconGap}px;
    `}
`